<template>
    <div class="address-card tw-flex tw-items-center">
        <b-img
                v-if="imageSrc"
                :src="imageSrc"
                class="address-card-img"
                height="80"
                width="80"
        />
        <div
                v-else
                class="map-icon"
        >
            <i
                    class="fa-solid fa-location-dot"
                    :style="{'color':computedPrimaryColor}"
            />
        </div>
        <div class="address-card-info tw-flex tw-justify-items-center tw-flex-col">
             <span class="address-card-info-street text-gray-900">
                {{ displayAddressDeliveryLine }}
            </span>
            <span class="address-card-info-city">
                {{ address.city }}, {{ address.state }} {{ address.zip }}
            </span>
        </div>
    </div>
</template>

<script>
import './AddressCard.scss';

export default {
    name: "AddressCard",
    props: {
        address: {
            type: Object,
            required: true
        },
        propertyImage: {
            type: String,
            default: ''
        },
        computedPrimaryColor: {
            type: String,
            default: ''
        }
    },

    computed: {
        imageSrc() {
            if (!this.propertyImage) {
                return '';
            }
            try {
                const url = new URL(this.propertyImage);
                return url.toString();
            } catch (e) {
                console.error(e);
            }

            return '';
        },
        displayAddressDeliveryLine() {
            if (this.address.deliveryLine) {
                return this.address.deliveryLine;
            }

            return `${this.address.streetNumber || ''} ${this.address.street || ''}`;
        }
    }

};
</script>
